import { ALLERGY_REACTANT_NAME } from "../utils/constants";
import BaseViewController from "./base-view-controller";

class AddAllergyViewController extends BaseViewController {
  handleButtonClick() {
    const { data, screenIndex, values, screenParams, nextScreen, settings } =
      this.appData;
    const availIndex = Object.keys(values).reduce((availIndexNum, key) => {
      if (key.startsWith("mhd_answers.293")) {
        const index = parseInt(key.split(".")[2], 10);
        return index >= availIndexNum ? index + 1 : availIndexNum;
      } else {
        return availIndexNum;
      }
    }, 0);
    const availPrefix = `mhd_answers.293.${availIndex}`;
    const myMedicalHistory =
      data.screens.find(s =>
        (s.params || "").includes("TDScreenOptionMedicalHistory")
      ) || data.screens.find(s => s.name === "MyMedicalHistory");

    const addAllergyLinkIndex = myMedicalHistory.fields.findIndex(
      f => f.name === "addAllergyLink"
    );
    myMedicalHistory.fields = [
      ...myMedicalHistory.fields.slice(0, addAllergyLinkIndex + availIndex + 1),
      {
        params:
          "TDFieldOptionIsMedicine|TDFieldOptionIsLast|TDFieldOptionAutoCorrectNone",
        name: `${availPrefix}.current_allergy_flg`,
        title: values.allergy_reactantName,
        type: "cellWithSubtitle",
        text: values.allergy_reaction,
        options: [
          {
            name: "Y",
            text: settings.translations.still_allergic,
            value: "Y",
            selected: values.statusQuestion === "Y"
          },
          {
            name: "N",
            text: settings.translations.no_longer_allergic,
            value: "N",
            selected: values.statusQuestion === "N"
          }
        ]
      },
      ...myMedicalHistory.fields.slice(addAllergyLinkIndex + availIndex + 1)
    ].filter(f => f.name !== "mhd_answers.293");
    nextScreen({
      data,
      screenIndex,
      formState: {
        ...values,
        [`${availPrefix}.reactant`]: values.allergy_reactantName,
        [`${availPrefix}.allergy_cd`]: screenParams.allergy_cd,
        [`${availPrefix}.allergy_type_cd`]: screenParams.allergy_type_cd,
        [`${availPrefix}.allergy_type`]: screenParams.allergy_type,
        [`${availPrefix}.reaction`]: values.allergy_reaction,
        [`${availPrefix}.current_allergy_flg`]: values.statusQuestion
      },
      action: {
        type: "screen",
        value: "MyMedicalHistory"
      },
      replaceHistory:
        this.screen.params === "TDScreenOptionAddAlergyScreen" ? 3 : 2
    });
    this.appData.handleChange({ [ALLERGY_REACTANT_NAME]: "" });
  }
}

export default AddAllergyViewController;
